import styled from 'styled-components';
export var Wrapper = /*#__PURE__*/styled.section.withConfig({
  componentId: "sc-1xxuk9t-0"
})(["width:100%;h2{font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";font-weight:600;color:", ";}"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.availabilitySection.description.color;
});